import React, { useState, useEffect, useRef } from "react";
import NavigationDrawer from "../../components/navigationDrawer/index";
import CustomBar from "../../components/customBar";
import AppContainer from "../../components/containers/AppContainer";
import { Button, Divider } from "@mui/material";
import { APP_ICONS } from "../../assets";
import AddIcon from "@mui/icons-material/Add";
import JobTitleAdd from "./jobTitleAdd";
import DynamicTable from "../../components/dynamicTable";
import { deleteJobTitle, getAllJobTitle } from "../../services/jobTitle";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import AppLoader from "../../components/loader/loader";

const selectInputWith = {
  width: { xs: "100%", md: "150px" },
};

const tableHeader = ["NAME", "PRICE", "ACTIONS"];
const displayRows = ["job_title", "price", "actions_button"];

const JobTitle = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(true);
  const snackRef = useRef();
  const handleDialogOpen = () => {
    setDialogOpen(true);
    setEditData(null); // Reset editData for a new category
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const fetchJobTitles = async () => {
    setLoading(true);

    try {
      const response = await getAllJobTitle();

      if (response.data.status === "success") {
        setTableData(response.data.data);
        setLoading(false);
      } else {
        snackRef.current.isOpenSnack({
          snackType: "error",
          snackMessage: `Failed to fetch categories: ${response.message}`,
        });
      }
    } catch (error) {
      snackRef.current.isOpenSnack({
        snackType: "error",
        snackMessage: "API Error: Failed to fetch categories",
      });
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on initial load
  useEffect(() => {
    fetchJobTitles();
  }, []);
  const handleEdit = (category) => {
    setEditData(category);
    setDialogOpen(true);
  };

  const handleDelete = (id) => {
    let params = {
      acknowledged: false,
    };
    deleteJobTitle(id, params)
      .then((response) => {
        snackRef.current.isOpenSnack({
          snackType: "success",
          snackMessage: "Company Deleted successfully",
        });
        fetchJobTitles();
      })
      .catch((err) => {
        console.error("Error deleting company:", err);
      });
  };

  return (
    <NavigationDrawer>
      {/* Mini Header */}
      <AppLoader isVisible={loading} />
      <CustomBar title={"JOB TITLE"} />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {/* JobTitleAdd Dialog */}
        <JobTitleAdd
          open={dialogOpen}
          onClose={handleDialogClose}
          fetchJobTitles={fetchJobTitles}
          type={editData ? "edit" : "add"}
          editData={editData}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleDialogOpen}
          sx={{
            width: "80px",
            margin: "10px",
          }}
        >
          <AddIcon /> Add
        </Button>
      </div>
      <AppContainer>
        <Divider />
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={tableData}
          showPagination={true}
          showUserMenu={true}
          isLoading={loading}
          onEdit={(row) => handleEdit(row)}
          onDelete={(row) => handleDelete(row._id)}
        />
      </AppContainer>
      <CustomSnackbar ref={snackRef} />
    </NavigationDrawer>
  );
};

export default JobTitle;
